export default {
  pages: {
    alifshopOffersShow: {
      toToStockLink: 'Перейти на склад',
    },
  },
};
